"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fixExternalImageSrc = function (src) {
    if (src.startsWith('//')) {
        return 'https:' + src;
    }
    return src;
};
exports.default = fixExternalImageSrc;
//# sourceMappingURL=fixExternalImageSrc.js.map